<template>
    <div>
        <transition name="modal" mode="out-in">
            <div v-show="show" class="fixed inset-0 z-30 overflow-y-auto">
                <div class="flex justify-center">
                    <div class="fixed inset-0 bg-gray-500 bg-opacity-50 transition-opacity backdrop-filter backdrop-blur-sm" aria-hidden="true"></div>
                    <transition name="slide" >
                        <div v-show="show" class="transform flex justify-center w-full">
                            <slot></slot>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        show: Boolean
    }
}
</script>